
import {
  FormControl,
  Box,
  FormHelperText,
  Slider,
  Typography,
} from '@mui/material';
import type { SliderProps } from '@mui/material';

interface TopPFieldProps {
  value: number;
  setValue: (value: number) => void;
}

export default function TopPField({ value, setValue, ...rest }: TopPFieldProps) {
  const handleChange: NonNullable<SliderProps['onChange']> = (_event, newValue) => {
    setValue(parseFloat(String(newValue)));
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <Typography>Top-p</Typography>
        <Slider
          {...rest}
          aria-label='Top-p'
          value={value}
          valueLabelDisplay='auto'
          aria-describedby='top-p-helper-text'
          onChange={handleChange}
          step={0.01}
          min={0}
          max={1}
        />

        <FormHelperText id='top-p-helper-text'>
          If set to less than 1, only the smallest set of most probable tokens
          with probabilities that add up to top_p or higher are kept for
          generation.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
